/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pace: NonNullable<unknown> }} Ui_Laps_PaceInputs */

const en_ui_laps_pace = /** @type {(inputs: Ui_Laps_PaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pace} /km`)
};

const de_ui_laps_pace = /** @type {(inputs: Ui_Laps_PaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pace} /km`)
};

/**
* | output |
* | --- |
* | "{pace} /km" |
*
* @param {Ui_Laps_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_pace = /** @type {((inputs: Ui_Laps_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_pace(inputs)
	return de_ui_laps_pace(inputs)
});